import React, { ReactElement, useEffect, useRef } from 'react'
import StaticPage, { staticPageHeaderHeight } from 'components/StaticPage/StaticPage'
import { Flex } from 'theme-ui'
import { withAlertContextProvider, AlertPresenter } from 'ui'
import UseCases from 'components/HomePage/UseCases'
import HowDoesControlDWorkSection from 'components/HomePage/HowDoesControlDWorkSection'
import { useLocation } from '@reach/router'
import WhatIsDNSAndProxySection from 'components/HomePage/WhatIsDNSAndProxySection'
import TakeBackYourInternetSection from 'components/HomePage/TakeBackYourInternetSection'
import FeaturesGrid from 'components/HomePage/FeaturesGrid'
import HowDoIUseControlDSection from 'components/HomePage/HowDoIUseControlDSection'
import TopSection from 'components/HomePage/TopSection'

export const homePageContentMaxWidth = ['47.2rem', '72rem', '108rem']

export default withAlertContextProvider(function HomePage(): ReactElement {
  const alertPresenterContainerRef = useRef<HTMLDivElement>(null)
  const location = useLocation()

  useEffect(() => {
    // fix for the page position issue on iOS 14
    !location.hash && (document.body.scrollTop = document.documentElement.scrollTop = 0)
  }, [location.hash])

  return (
    <StaticPage hasMaxWidth={false}>
      <Flex
        sx={{
          width: '100%',
          height: '100%',
          flexDirection: 'column',
          alignItems: 'center',
          '& [id]': {
            scrollMarginTop: staticPageHeaderHeight,
          },
        }}
      >
        <TopSection />
        <Flex
          sx={{
            maxWidth: ['100%', '100%', '108rem'],
            px: ['1.6rem', '4.8rem', 0],
            flexDirection: 'column',
          }}
        >
          <UseCases />
          <HowDoesControlDWorkSection />
          <HowDoIUseControlDSection />
          <WhatIsDNSAndProxySection />
          <FeaturesGrid />
          <TakeBackYourInternetSection />
        </Flex>
      </Flex>
      <Flex
        sx={{
          display: 'flex',
          width: '100%',
          height: '100%',
          position: 'fixed',
          justifyContent: 'center',
          zIndex: 'zIndex650',
          pointerEvents: 'none',
        }}
      >
        <Flex
          ref={alertPresenterContainerRef}
          sx={{
            width: '100%',
            maxWidth: ['100%', '100%', '108rem'],
            mx: ['1.6rem', '1.6rem', '4.8rem'],
            [`@media screen and (min-width: 1120px) and (max-width: 1450px)`]: {
              mx: '2.4rem',
            },
          }}
        >
          <AlertPresenter containerRef={alertPresenterContainerRef} />
        </Flex>
      </Flex>
    </StaticPage>
  )
})
